<script>
  import { clickStoryData, clickStoryUrlData } from "../Api/store";
  import Wisch from "../Component/Wisch.svelte";

  export let urlPathId;

  function getLocationPath(current) {
    return `${$clickStoryUrlData}/${urlPathId}/${parseInt(current) + 1}`;
  }
</script>

<Wisch {getLocationPath} data={clickStoryData} enableOverview={false} />
